import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuAccordian from "./MenuAccordian";
import PlayModeSelector from "./playMode.js";
import MyPresetAuthManager from "../MyPresetManager/MyPresetAuthManager.js";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../Backend/Firebase";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      className="menu-tab-panel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div className="menu-tab-panel-content">{children}</div>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MenuTabs(props) {
  const [value, setValue] = React.useState(() => props.user || auth.currentUser ? 2 : 1);
  const [isPresetFlowActive, setIsPresetFlowActive] = React.useState(false);
  const hasChosenTab = React.useRef(false);
  const { setUser } = props;

  React.useEffect(() => onAuthStateChanged(auth, (user) => {
    // Restore the saved login after reload, even before My Presets is opened.
    setUser(user || null);
    if (!hasChosenTab.current) setValue(user ? 2 : 1);
  }), [setUser]);

  const handleChange = (event, newValue) => {
    hasChosenTab.current = true;
    setValue(newValue);
    setIsPresetFlowActive(false);
  };

  return (
    <div
      className={`menu-surface ${
        isPresetFlowActive ? "menu-surface-flow-active" : ""
      }`}
    >
      {!isPresetFlowActive && (
        <div className="menu-tabs-header">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Task menu sections"
            className="menu-tabs"
            variant="fullWidth"
          >
            <Tab label="Play mode" {...a11yProps(0)} />
            <Tab label="Presets" {...a11yProps(1)} />
            <Tab label="My presets" {...a11yProps(2)} />
          </Tabs>
          <button
            type="button"
            className="menu-close-button"
            onClick={() => props.setIsMenuOn(false)}
            aria-label="Close menu"
          >
            <CloseRoundedIcon />
          </button>
        </div>
      )}

      <div className="menu-tabs-body">
        <CustomTabPanel value={value} index={0}>
          <PlayModeSelector />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <MenuAccordian
            setTaskName={props.setTaskName}
            setIsMenuOn={props.setIsMenuOn}
            addTasksToList={props.addTasksToList}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <MyPresetAuthManager
            setTaskName={props.setTaskName}
            setIsMenuOn={props.setIsMenuOn}
            addTasksToList={props.addTasksToList}
            user={props.user}
            setUser={props.setUser}
            tasks={props.tasks}
            onFlowChange={setIsPresetFlowActive}
          />
        </CustomTabPanel>
      </div>
    </div>
  );
}

// Arena
